import { CaretRightOutlined } from '@ant-design/icons';
import { type CSSProperties, useRef, useState } from 'react';

import { CenterFlex, Flex, ScrollVFlex } from '@/components/base';
import SelectPortal from '@/components/Select/SelectPortal';
import { Option } from '@/components/Select/styled';
import { MainText } from '@/components/Typography/NamedTypo';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

type Props = {
  filterList: FilterOptionT[];
  status: boolean;
  pos?: CSSProperties;
  onFilterClick: (filter: FilterOptionT) => void;
  closeDropdown: () => void;
};

const FilterListSelect = (props: Props) => {
  return (
    <SelectPortal
      close={props.closeDropdown}
      status={props.status}
      style={props.pos}
    >
      <Dropdown {...props} />
    </SelectPortal>
  );
};

const Dropdown = (props: Props) => {
  const color = useColor();
  const [childFilter, setChildFilter] = useState<Props | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <ScrollVFlex ref={dropdownRef} style={{ maxHeight: '40vh' }}>
        <Flex d="column" style={{ padding: 4 }} g="4px">
          {props.filterList?.map((filter) => {
            if (filter.hidden) {
              return null;
            }
            return (
              <Option
                j="space-between"
                key={filter.columnKey}
                focused={false}
                style={{ padding: '6px 8px' }}
                onClick={() => {
                  if (filter.children) {
                    setChildFilter({
                      status: true,
                      filterList: filter.children,
                      pos: {
                        ...props.pos,
                        left:
                          (dropdownRef.current?.getBoundingClientRect?.()
                            ?.right || 0) + 8,
                      },
                      onFilterClick: props.onFilterClick,
                      closeDropdown: () => setChildFilter(null),
                    });
                  } else {
                    props.onFilterClick(filter);
                  }
                }}
              >
                <Typo type="label2" color={color.gray700}>
                  {filter.columnName}
                </Typo>
                {filter.children && (
                  <CaretRightOutlined
                    style={{ position: 'relative', left: 8 }}
                  />
                )}
              </Option>
            );
          })}
          {!props.filterList?.length && (
            <CenterFlex style={{ height: 100 }}>
              <MainText dim>No data</MainText>
            </CenterFlex>
          )}
        </Flex>
      </ScrollVFlex>
      {props.status && childFilter && <FilterListSelect {...childFilter} />}
    </>
  );
};

export default FilterListSelect;
